import { Key } from 'react';
import { DonorType } from '@/api/apis/case';
import { RSAssignmentCandidate } from '@/api/apis/resources';
import { columns } from '../config';
import {
  LocationCell,
  MatchCell,
  OrgansLastCall,
  ReservationCondition,
  ReserveButton,
  ResourceNameCell,
  ThirtyDays,
} from '../../components';
import { formatHomeLocation } from '../utils';

export const renderEmployeeSurgeonTableCell =
  (
    orTime: string,
    isLogistics: boolean,
    donorType: DonorType,
    onReserve: (csCandidate: RSAssignmentCandidate) => void,
    caseName?: string,
  ) =>
  (surgeonData: RSAssignmentCandidate & { isSelected?: boolean }, key: Key) => {
    const {
      isSelected,
      employeeFullName,
      employeeProfilePhoto,
      shiftCertificates,
      employeeCertificates,
      lastCallDays,
      lastTrackedLocation,
      match,
      onCallAfterTargetMinutes,
      onCallBeforeTargetMinutes,
      onRestEndsBeforeTargetMinutes,
      conflictedReservation,
      conflictedRest,
      homeLocation,
      days30Stats,
      unavailabilities,
    } = surgeonData;

    const handleReserve = () => {
      onReserve(surgeonData);
    };

    switch (key) {
      case columns.name.key:
        return <ResourceNameCell fullName={employeeFullName} photoPath={employeeProfilePhoto} />;
      case columns.organLastCall.key:
        return (
          <OrgansLastCall
            isClinicalSpecialist
            donorType={donorType}
            shiftCertificates={shiftCertificates}
            employeeCertificates={employeeCertificates}
            lastCallDaysByOrgan={lastCallDays.forCaseDonorByOrgan}
            lastCallDaysByDonorAndOrgan={lastCallDays.byDonorAndOrgan}
          />
        );
      case columns.thirtyDays.key:
        return <ThirtyDays stats={days30Stats} />;
      case columns.location.key:
        return (
          <LocationCell locationName={formatHomeLocation(homeLocation)} lastTrackedLocation={lastTrackedLocation} />
        );
      case columns.match.key:
        return <MatchCell matchType={match.matchType} />;
      case columns.reservationCondition.key:
        return (
          <ReservationCondition
            unavailabilities={unavailabilities}
            orTime={orTime}
            conflictReservation={conflictedReservation}
            conflictRest={conflictedRest}
            match={match}
            onCallAfterTargetMinutes={onCallAfterTargetMinutes}
            onCallBeforeTargetMinutes={onCallBeforeTargetMinutes}
            onRestEndsBeforeTargetMinutes={onRestEndsBeforeTargetMinutes}
            caseName={caseName}
          />
        );
      case columns.reserve.key:
        return (
          <ReserveButton
            onReserve={handleReserve}
            isSelected={isSelected}
            isLogistics={isLogistics}
            assignActionType={match.availableActionType}
          />
        );
      default:
        return null;
    }
  };
